"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WrapperInput = exports.Form = void 0;
const flora_react_1 = require("@grupoboticario/flora-react");
exports.Form = (0, flora_react_1.styled)('form', {
    position: 'relative',
});
exports.WrapperInput = (0, flora_react_1.styled)('div', {
    'input::-webkit-search-cancel-button': {
        '-webkit-appearance': 'none',
    },
});
